export enum AdErrorCode {
    PlaybackError = 'playbackError',
    ChunkFailed = 'chunkFailed',
    ChunkTimeout = 'chunkTimeout',
}
